var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayArrowR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 54,
  height: 54,
  viewBox: "0 0 54 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 52.5,
  height: 52.5,
  rx: 11.25,
  stroke: "#C0C0C0",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 18L22.5 26.9995L31.5 36",
  stroke: "#C0C0C0",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayArrowR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-arrow-r.3355e4f93485bf3f6dc898c7eeaa633e.svg";